# get server side data passed through data attributes
window.currentUser = ->
  $("#fedora-data").data() || false
window.setFedoraKeys = ->
  @fedora_keys = $("#fedora-keys").data()
  @school_data = currentUser()
  @fedora_user = currentUser()
  @fedora_user.completedLectureIds = [] unless _.isNumber(@fedora_user.id)


# Customers are relying on this awful code, see github issue #4545
window.currentCourse = ->
  path = location.pathname
  if path.indexOf("/courses/") is 0 and path.indexOf("/courses/enrolled") is -1
    # 9 is length of /courses/
    window.current_course_slug = window.location.pathname.slice(9).split("/")[0]
    window.course_params = {friendly_url: window.current_course_slug}
    window.current_course = courseData(course_params)
    window.current_course
  else
    {}

window.currentLectureId = ->
  return null unless location.pathname.indexOf("/lectures/") isnt -1
  parseInt(location.pathname.slice(location.pathname.indexOf("lectures") + "lectures/".length))

$(document).on "ready page:load", ->
  setFedoraKeys()
  $(".course-listing").click (event) ->
    event.preventDefault()
    Turbolinks.visit($(this).data().courseUrl)

  createAccessLimitText = (date) ->
    dateObj = date && window.moment && window.moment(date)
    if !dateObj || !dateObj.isValid()
      return ""
    return dateObj.format('DD MMM YYYY')

  setupAccessLimitToolTipText = ->
    tooltipEl = document.querySelector('.course-access-limit-tool-tip-icon')
    tooltipText = tooltipEl?.dataset?.tooltipText
    if tooltipEl && tooltipText && window.tooltipComponent
      window.tooltipComponent(tooltipText, tooltipEl, 'course-access-limit-tool-tip')

  setupAccessLimitToolTipText()

  _.forEach _.toPairs(fedora_user.reportCard), (data_array) ->
    courseId = data_array[0]
    reportCard = data_array[1]
    courseBox = $('.course-listing[data-course-id="' + courseId + '"]')

    # add access limit date
    accessLimitedAtText = createAccessLimitText(reportCard.access_limited_at)
    if accessLimitedAtText
      accesslimitEl = courseBox.find('.course-access-limit')
      accesslimitEl?.removeClass("hidden")
      accesslimitEl?.find('span')?.text(accessLimitedAtText)

    progressBar = courseBox.find('.progressbar')
    percentageBox = courseBox.find(".percentage")
    priceBox = courseBox.find(".course-price")
    subtitle = courseBox.find(".course-listing-subtitle")
    subtitle?.addClass("hidden")
    subtitle?.attr("aria-hidden", "true")
    priceBox?.parent()?.addClass("hidden")
    priceBox?.parent()?.attr("aria-hidden", "true")
    percentageBoxContainer = $(courseBox.find(".percentage")).parent().parent()
    progressBarFill = courseBox?.find(".progressbar-fill")
    percentCompleteRounded = if reportCard.percent_complete > 100 then 100 else reportCard.percent_complete
    progressBarFill.attr("style", "min-width: #{percentCompleteRounded}%;")
    # show the progress bar
    percentageBoxContainer?.removeClass("hidden")
    percentageBoxContainer?.parent()?.removeClass("hidden")
    percentageBoxContainer?.parent()?.attr("aria-hidden", "false")
    progressBar.parent().removeClass("hidden")
    progressBar.parent().attr("aria-hidden", "false")
    courseBoxParent = courseBox.find(".course-progress")?.parent()
    courseBoxParent?.removeClass("hidden")
    courseBoxParent?.attr("aria-hidden", "false")
    # set Percent complete
    percentageBox?.text(percentCompleteRounded + "%")
    progressBarFill?.attr("aria-valuenow", percentCompleteRounded + "%")
    return

  return true

